import { useSessionTyped } from './useSession'

export const useUserId = () => {
  const session = useSessionTyped()
  const userId = session?.id
  return userId
}
